<div class="webinars-block" [style.color]="block.textColor">
  <div class="content px-0">
    <div class="title-wrapper">
      <h1 [rtl]="block.langcode">{{
        block.title || ('MENU.events' | translate)}}
      </h1>

      <button
        mat-button
        class="button button--transparent button--outline"
        [style.border-color]="block.textColor"
        [style.color]="block.textColor"
        [disableRipple]="true"
      [routerLink]="['/webinars']">{{'EVENTS.view_all_events' | translate}}</button>
    </div>

    <div class="webinar-carousel">
      <app-carousel
        type="webinar"
        [items]="webinars$ | async"
      [config]="carouselConfig"></app-carousel>

      @if (isLoading) {
        <div class="placeholders-grid">
          @for (item of placeholders; track $index) {
            <lib-skeleton-loader class="placeholder" height="392px" width="420px"></lib-skeleton-loader>
          }
        </div>
      }
    </div>
  </div>
</div>
